<template>
    <div v-if="isLoaded">
        <div class="content-body" v-bind:class="{ fullscreen_expand: isFullscreen }">
            <div class="row match-height">
                <div class="col-xl-12 col-lg-12">
                    <div class="card" style="">
                        <div class="card-header">
                            <h4 class="card-title">Cliente X Unidade</h4>
                            <a class="heading-elements-toggle"><i class="fa fa-ellipsis-v font-medium-3" @click="setSubMenuShowHideFw(getSubMenuShowHideFw())"></i></a>
                            <div class="heading-elements"  v-bind:class="{ visible: getSubMenuShowHideFw(), '': !getSubMenuShowHideFw() }">
                                <ul class="list-inline mb-0">
                                    <li><a @click="onCreate()" v-b-tooltip title="Cadastrar" v-if="getPermissionFw('parambanco.store')"><i class="fa fa-plus"></i></a></li>
                                    <li><a @click="onFilterReset()" v-b-tooltip title="Atualizar listagem"><i class="ft-rotate-cw"></i></a></li>
                                    <li><a @click="expandFullscreenFw()" v-b-tooltip title="Expande a tela" v-if="!isFullscreen"><i class="ft-maximize"></i></a></li>
                                    <li><a @click="expandFullscreenFw()" v-b-tooltip title="Minimiza a tela" v-if="isFullscreen"><i class="ft-minimize"></i></a></li>
                                    <li><a @click="onFilterShowHideFw()" v-b-tooltip.hover.left="'Filtros'"><i class="fa fa-filter"></i></a></li>
                                    <li><a @click="onActivateDesactivate(1, null, false)" v-b-tooltip title="Ativar Registros"  v-if="getPermissionFw('parambanco.status')"><i class="fa fa-thumbs-o-up"></i></a></li>
                                    <li><a @click="onActivateDesactivate(2, null, false)" v-b-tooltip title="Inutilizar Registros"  v-if="getPermissionFw('parambanco.status')"><i class="fa fa-thumbs-o-down"></i></a></li>
                                </ul>
                            </div>
                        </div>
                    <div class="card-content">
                        <div class="table-responsive">
                            <div v-if="vuetableFilterRow">
                                <vuetable-filterbar>
                                </vuetable-filterbar>
                            </div>
                        <div class="loadingDataPosition">
                            <div class="loadingData" v-if="loadingData"><div class="loadingDataSpinner"><spinner v-if="loadingData" text-fg-color="#ffffff" message="Carregando..."></spinner></div></div>
                            <vuetable ref="vuetable"
                                    api-url="/api/clienteunidade"
                                    :fields="fields"
                                    :css="css"
                                    :append-params="moreParams"
                                    track-by="cliuni_id"
                                    pagination-path=""
                                    @vuetable:load-error="onError"
                                    @vuetable:pagination-data="onPaginationData"
                                    @vuetable:loaded="onLoaded"
                                  >
                                  <template slot="status" slot-scope="props">
                                      <span class="badge badge-success" v-if="props.rowData.status.valor==1">{{ props.rowData.status.descr }}</span>
                                      <span class="badge badge-danger" v-if="props.rowData.status.valor==2">{{ props.rowData.status.descr }}</span>
                                  </template>
                                  <template slot="cliente_cnpj" slot-scope="props">
                                      {{ajustaMascara(onFormataCnpj(props.rowData.pessoa.pessoa_juridica.cnpj_base,props.rowData.pessoa.pessoa_juridica.cnpj_filial,props.rowData.pessoa.pessoa_juridica.cnpj_digito),2)}}
                                  </template>
                                  <template slot="cliente_razao" slot-scope="props">
                                      {{props.rowData.pessoa.pessoa_juridica.razao_social}}
                                  </template>
                                  <template slot="unidade_cnpj" slot-scope="props">
                                      {{ajustaMascara(onFormataCnpj(props.rowData.unidade.pessoa.pessoa_juridica.cnpj_base,props.rowData.unidade.pessoa.pessoa_juridica.cnpj_filial,props.rowData.unidade.pessoa.pessoa_juridica.cnpj_digito),2)}}
                                  </template>
                                  <template slot="unidade_razao" slot-scope="props">
                                      {{props.rowData.unidade.pessoa.pessoa_juridica.razao_social}}
                                  </template>
                                  <template slot="actions" slot-scope="props">
                                    <div class="custom-actions">
                                        <a @click="onEdit(props.rowData, props.rowIndex)" v-b-tooltip title="Editar"  v-if="getPermissionFw('parambanco.update')"><i class="fa fa-edit"></i></a>
                                        <span v-if="getPermissionFw('parambanco.status')">
                                            <a v-if="props.rowData.status.valor==2" @click="onActivateDesactivate(1, props.rowData, true)" v-b-tooltip title="Ativar"><i class="fa fa-thumbs-o-up"></i></a>
                                            <a v-if="props.rowData.status.valor==1" @click="onActivateDesactivate(2, props.rowData, true)" v-b-tooltip title="Inativar"><i class="fa fa-thumbs-o-down"></i></a>
                                        </span>
                                    </div>
                                  </template>
                            </vuetable>
                        </div>
                    <div>
                        <div class='col-md-12'>
                            <div class="pull-left pagination-detail">
                                <vuetable-pagination-info ref="paginationInfo"
                                                          :css="css.pagination"
                                                          info-class="pull-left"
                                ></vuetable-pagination-info>
                            </div>
                            <div class="pull-right m-a-0">
                                <vuetable-pagination ref="pagination"
                                                     :css="css.pagination"
                                                     @vuetable-pagination:change-page="onChangePage"
                                ></vuetable-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<ClienteXUnidadeForm ref="clientexunidadeform" />
              </div>
          </div>
</template>
<script>
import { formatCNPJFromParts } from "../utils";

import Vuetable from '../components/Vuetable'
import VuetablePagination from '../components/VuetablePagination'
import VuetablePaginationInfo from '../components/VuetablePaginationInfo'
import ClienteXUnidadeFilterBar from './ClienteXUnidadeFilterBar'
import ClienteXUnidadeForm from './ClienteXUnidadeForm.vue'

export default {
components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
    ClienteXUnidadeForm,
    'vuetable-filterbar': ClienteXUnidadeFilterBar
},
data () {
    return {
      dataExport: [],
      modal_titulo: '',
      modal_botao: '',
      modal_acao: '',
      optionsStatus:[],
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      form: new Form({ cd: '',
                       descr: '',
                       parban_id: '',
                       status: []
                   }),
     helpForm: new Form({recordCollection: [], status: '',statusRecord: []}),
    fields: [
      {
          name: '__checkbox',
          titleClass: 'center aligned',
          dataClass: 'center aligned'
      },
      {
        name: '__slot:cliente_cnpj',
        title: 'CNPJ',
        sortField: 'cliente_cnpj'
      },
      {
        name: '__slot:cliente_razao',
        title: 'Razão Social',
        sortField: 'cliente_razao'
      },
      {
        name: '__slot:unidade_cnpj',
        title: 'CNPJ - Unidade',
        sortField: 'unidade_cnpj'
      },
      {
        name: '__slot:unidade_razao',
        title: 'Razão Social - Unidade',
        sortField: 'unidade_razao'
      },
      {
        name: '__slot:status',
        title: 'Status',
        sortField: 'status'
      },
      {
          name: '__slot:actions',   // <----
          title: 'Ações',
          titleClass: 'center aligned',
          dataClass: 'center aligned'
      }
  ],
  css: {
      loadingClass: 'loading',
      ascendingIcon: 'glyphicon glyphicon-chevron-up',
      descendingIcon: 'glyphicon glyphicon-chevron-down',
      handleIcon: 'glyphicon glyphicon-menu-hamburger',
  },
  moreParams: {}
   }
},
mounted() {
    this.$events.$on('filter-set', eventData => this.onFilterSet(eventData));
    this.$events.$on('filter-reset', e => this.onFilterReset());
    this.getLivGeral();
  },
methods: {
    onPaginationData (paginationData) {
      this.$refs.pagination.setPaginationData(paginationData)
      this.$refs.paginationInfo.setPaginationData(paginationData)
    },
    onChangePage (page) {
      this.$refs.vuetable.changePage(page)
    },
    onFilterSet (data_filter) {
        this.loadingData = true;
        this.moreParams = {
            'pessoa': data_filter.pessoa.value,
            'unidade': data_filter.unidade.value,
            'status': data_filter.status.value
        }
        Vue.nextTick( () => {this.$refs.vuetable.reload(); })
    },
    onFilterReset () {
        this.loadingData = true;
        this.moreParams = {}
        Vue.nextTick( () => this.$refs.vuetable.refresh())
    },
    onLoaded: function () {
        this.dataExport = this.$refs.vuetable.tableData;
        this.loadingData = false;
        this.$store.commit('setVuetableFilterButton', false);
    },
    onCreate ()
    {
      this.$refs.clientexunidadeform.onCreate();
    },
    onEdit (data)
    {
      this.$refs.clientexunidadeform.onEdit(data);
    },
    onActivateDesactivate(action, data, tipo)
    {
        // Tipo = true = Checkbox
        this.helpForm.status = action;
        if(tipo)
        {

            this.helpForm.statusRecord = [];
            this.helpForm.statusRecord.push(data.cliuni_id );
        }
        else
        {
            this.helpForm.statusRecord = [];
            this.$refs.vuetable.selectedTo.forEach((obj)=>{
                this.helpForm.statusRecord.push(obj)
            });
        }
        this.$refs.clientexunidadeform.onActivateDesactivate(this.helpForm);
    },
    onError(response) {
        new ReturnApi(response.response, this, true, true, false);
    },
    getLivGeral() {
        this.helpForm.get('/api/clienteunidade/jsonlist').then(response =>
        {
            new ReturnApi(response, this, true, false, false);
            response.status.forEach((obj)=>{
                this.optionsStatus.push({
                    label: obj.descr, value: obj.valor, text:obj.descr
                })
            })
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this)
        });
    },
        onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
      return formatCNPJFromParts(cnpj_base, cnpj_filial, cnpj_digito);
    },
    ajustaMascara(data, tipo){
    	if(tipo === 1 ){//cpf
			return data.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
		}
		if(tipo === 2 ){//cnpj
			return data.replace(/([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})([A-Z0-9]{2})/, "$1.$2.$3/$4-$5");
		}
    },
},
computed: {
    vuetableFilterRow: {
      get () {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
        get() {
            return this.$store.getters.isloaded;
        }
    },
    isFullscreen: {
        get() {
            return this.$store.getters.is_full_screen;
        }
    }
}
}
</script>